/** Components */
import {
    RequestIdWithWarning,
    replaceRequestId,
    RequestDays,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';
import { AmountRequest } from '../../components/utilities/Table/generalColumns/AmountRequest';
import { AnalistWithTooltip } from '../../components/utilities/Table/generalColumns/AnalistWithTooltip';
import { DefineDate } from '../../components/utilities/Table/generalColumns/DefineDate';

const commonColumns = [
    RequestIdWithWarning('gestionsolicitud.fecha_mesa_aprobacion'),
    {
        Header: 'Fecha Análisis',
        accessor: 'gestionsolicitud.fecha_mesa_aprobacion',
    },
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    OfficeRequest,
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    ExecutiveWithTooltip,
    AmountRequest,
    AnalistWithTooltip,
];

export const requestsListStatus = [
    {
        id: 'tableBGAprobador',
        label: 'EN BOLSA GENERAL',
        status: 40,
        responsable: false,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));

            return cols;
        })(),
        buttonAction: [{ name: 'takeRequest' }],
    },
    {
        id: 'tableEPAprobador',
        label: 'EN PROCESO',
        status: 40,
        responsable: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));

            return cols;
        })(),
    },
    {
        id: 'tablePAprobador',
        label: 'PROCESADAS',
        status: false,
        responsable: false,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 40,
                operator: '%26',
            },
            {
                name: 'gestionsolicitud__usuario_comite',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_rechazo',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
        ],
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols[1] = DefineDate('comite', 'Fecha Aprobación');
                cols.splice(9, 0, StatusWithTooltip);
                cols.splice(10, 0, CausalRequest);
                return cols;
            })()
        ),

        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
];
